import type { TemplateVariableType } from './types.ts';
import { i18n } from './i18n.ts';

export const defaultVariableName: string = i18n.templateVariableDefault.defaultMessage;
export const TEXT_TYPE: TemplateVariableType = 'text';
export const MULTI_LINES_TYPE: TemplateVariableType = 'textarea';
export const LIST_TYPE: TemplateVariableType = 'select';
export const ROWS_DEFAULT = 5;
export const COLUMNS_DEFAULT = 100;
